if (!customElements.get('wg-back-in-stock')) {
  customElements.define(
    'wg-back-in-stock',
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialize()) return;

        this.readyObserver = new MutationObserver(() => {
          if (this.initialize()) {
            this.readyObserver.disconnect();
          }
        });

        this.readyObserver.observe(this, {
          childList: true,
          subtree: true
        });
      }

      initialize() {
        if (this.initialized) return true;

        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-wg-bis-open]');
        this.email = this.querySelector('.wg-bis__email');
        this.notice = this.querySelector('.wg-bis__notice');
        this.submitButton = this.querySelector('.wg-bis__submit');

        if (
          !this.dialog ||
          !this.trigger ||
          !this.email ||
          !this.notice ||
          !this.submitButton
        ) {
          return false;
        }

        this.initialized = true;
        this.busy = false;
        this.succeeded = false;

        this.showStatus = (message, state) => {
          this.notice.textContent = message;
          this.notice.dataset.state = state;
          this.notice.hidden = false;

          if (this.dialog.open && state !== 'pending') {
            this.notice.focus();
          }
        };

        this.attemptSignup = async () => {
          if (this.busy || this.succeeded) return;

          this.email.value = this.email.value.trim();

          if (!this.email.reportValidity()) return;

          const variantId = this.dataset.variantId;
          const productForm = this.closest('form');
          const selectedId = productForm
            ? new FormData(productForm).get('id')
            : null;

          if (
            !/^\d+$/.test(variantId) ||
            !this.dataset.companyId ||
            (selectedId !== null && String(selectedId) !== variantId)
          ) {
            this.showStatus(this.dataset.errorMessage, 'error');
            return;
          }

          const payload = {
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: this.email.value
                    }
                  }
                },
                channels: ['EMAIL']
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: '$shopify:::$default:::' + variantId
                  }
                }
              }
            }
          };

          this.busy = true;
          this.submitButton.disabled = true;
          this.email.disabled = true;
          this.submitButton.setAttribute('aria-busy', 'true');
          this.showStatus(this.dataset.submittingMessage, 'pending');

          this.controller = new AbortController();

          const timeout = setTimeout(() => {
            this.controller.abort();
          }, 15000);

          try {
            const response = await fetch(
              'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
                encodeURIComponent(this.dataset.companyId),
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  revision: '2026-07-15'
                },
                body: JSON.stringify(payload),
                signal: this.controller.signal
              }
            );

            if (!this.isConnected) return;

            if (response.status === 202) {
              this.succeeded = true;
              this.showStatus(this.dataset.successMessage, 'success');
            } else {
              this.showStatus(
                response.status === 429
                  ? this.dataset.rateLimitMessage
                  : this.dataset.errorMessage,
                'error'
              );
            }
          } catch {
            if (this.isConnected) {
              this.showStatus(this.dataset.errorMessage, 'error');
            }
          } finally {
            clearTimeout(timeout);
            this.busy = false;
            this.submitButton.removeAttribute('aria-busy');
            this.submitButton.disabled = this.succeeded;
            this.email.disabled = this.succeeded;
          }
        };

        this.onClick = (event) => {
          if (event.target.closest('[data-wg-bis-open]')) {
            if (!this.dialog.open) {
              this.dialog.showModal();
            }
          } else if (event.target.closest('[data-wg-bis-close]')) {
            this.dialog.close();
          } else if (event.target.closest('.wg-bis__submit')) {
            this.attemptSignup();
          }
        };

        this.onKeydown = (event) => {
          if (event.key === 'Enter' && event.target === this.email) {
            event.preventDefault();
            event.stopPropagation();
            this.attemptSignup();
          }
        };

        this.onClose = () => {
          if (this.trigger.isConnected) {
            this.trigger.focus();
          }
        };

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.dialog.addEventListener('close', this.onClose);

        this.trigger.disabled = false;

        return true;
      }

      disconnectedCallback() {
        this.readyObserver?.disconnect();
        this.initialized = false;

        if (this.trigger) {
          this.trigger.disabled = true;
        }

        this.controller?.abort();

        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.dialog?.removeEventListener('close', this.onClose);

        if (this.dialog?.open) {
          this.dialog.close();
        }
      }
    }
  );
}